import React, { useState, useContext } from "react";
import { StateContext } from "../../../state";
import Button, { ButtonContainer } from '../../library/Buttons';
import StartOver from '../../library/StartOver';
import { substituteVariablesInString } from "../../../utils/substitutions";

export const FinixAcceptFlow = ({acceptPayment, children}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [{configuration, payment, paymentNetworkConfig}] = useContext(StateContext);
  const dataForVariableSubstitutions = {payment, paymentNetwork: paymentNetworkConfig};
  const label = substituteVariablesInString(configuration.acceptPayment.btnLabel, dataForVariableSubstitutions);

  const onSubmit = () => {
    setIsFetching(true);
    acceptPayment();
  };

  const View = children;

  return (
    <View>
      <ButtonContainer>
        <Button
          onClick={onSubmit}
          label={label}
          disabled={isFetching}
        />
      </ButtonContainer>
      <StartOver/>
    </View>
  );
};

export default FinixAcceptFlow;
